const analytics = {
  track: (name, context) => {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track(name, context);
    }
    if (typeof gtag !== 'undefined' && (!context || !context.nonInteraction)) {
      gtag('event', name, context);
    }
    console.info(`Logged "${name}"`, context);
  },
  trackPageChange: (location) => {
    if (typeof gtag !== 'undefined') {
      gtag('config', 'UA-135627396-1', {
        page_path: location.pathname,
      });
    }
    console.info(`Logged page view: ${location.pathname}`);
  },
};

export default analytics;
